'use client';

/**
 * Footer Wrapper Component
 * Dynamically switches between footer designs based on theme configuration.
 */

import { useSettings } from '@/themes/core/hooks';
import { COMPONENT_REGISTRY } from '@/config/ecoBuilder/component-registry';

import { Menu } from '@/types/navigation';
import { SiteData } from '../../types';

interface FooterProps {
    site: SiteData;
    customMenus?: Menu[];
}

export function Footer(props: FooterProps) {
    const { footer } = useSettings();

    // Determine the footer type (defaulting to standard_footer)
    const footerType = footer?.footerType === 'modern' ? 'modern_footer' : 'standard_footer';

    // Get the component from registry
    const FooterComponent = COMPONENT_REGISTRY[footerType]?.component;

    if (!FooterComponent) {
        console.warn(`Footer component type "${footerType}" not found.`);
        return null;
    }

    return (
        <FooterComponent
            site={props.site}
            customMenus={props.customMenus}
            footerSettings={footer}
        />
    );
}

export default Footer;
